import React, {useCallback, useEffect, useMemo, useState} from 'react';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import useQuizList from "./useQuizList";
import QueryTable from "../../../../ui/QueryTable";
import {makeStyles} from "@material-ui/core/styles";
import useQuery from "../../../../ui/QueryTable/useQuery";
import DeleteConfirmationModal from "../../../../ui/DeleteConfirmationModal";
import AddButton from "../../../../ui/AddButton";
import AddQuizModal from "../../components/AddQuizModal";
import QuizDrawer from "../../components/QuizDrawer";

const items = [
  {
    label: "Опросы",
    link: "/work/app/quiz"
  },
  {
    label: "Проведение опросов",
    link: "#"
  },
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const QuizList = () => {
  const {isCreatingQuiz, isDeletingQuizs,
  createQuiz, deleteQuizs} = useQuizList();
  const [focusedQuiz, setFocusedQuiz] = useState(-1);
  const [selection, setSelection] = useState([]);
  const [addQuizOpen, setAddQuizOpen] = useState(false);
  const [deleteQuizOpen, setDeleteQuizOpen] = useState(false);

  const {root} = useStyles();
  const query = useQuery(18);

  const actionsDisabled = isCreatingQuiz || isDeletingQuizs;

  useEffect(() => {
    query.load();
  }, []);

  const createQuizChain = useCallback((form) => {
    return createQuiz(form)
      .then(() => {
        setAddQuizOpen(false);
        query.refresh();
      }, () => {
        setAddQuizOpen(false);
        query.refresh();
      })
  }, [setAddQuizOpen, createQuiz, query]);

  const deleteQuizsChain = useCallback(() => {
    return deleteQuizs(selection)
      .then(() => {
        setDeleteQuizOpen(false);
        query.refresh();
      }, () => {
        setDeleteQuizOpen(false);
        query.refresh();
      })
  }, [setDeleteQuizOpen, deleteQuizs, selection, query]);

  const TableRowClick = useCallback((e) => {
    const focusedQuiz = e ? e.key : -1;
    setFocusedQuiz(focusedQuiz);
  }, [setFocusedQuiz]);

  const TableSelectionChanged = useCallback(e => {
    setSelection(e.selectedRowKeys || []);
  }, [setSelection]);

  const showDeleteModal = useCallback(() => {
    setDeleteQuizOpen(!deleteQuizOpen);
  }, [deleteQuizOpen]);

  const showAddModal = useCallback(() => {
    setAddQuizOpen(!addQuizOpen)
  }, [addQuizOpen]);

  const secondaryActions = useMemo(() => {
    return [
      {
        label: "Удалить выбранные",
        onClick: showDeleteModal,
        disabled: actionsDisabled || (!selection || selection.length === 0)
      },
    ]
  }, [showDeleteModal, selection]);

  return (
    <div>
      <AddQuizModal
        open={addQuizOpen}
        handleClose={showAddModal}
        createQuiz={createQuizChain}
        isCreatingQuiz={isCreatingQuiz}/>
      <DeleteConfirmationModal
        modalText="Удалить выбранные опросы?"
        open={deleteQuizOpen}
        onConfirm={deleteQuizsChain}
        handleClose={showDeleteModal}
      />
      <Breadcrumbs items={items} />
      <div className={root}>
        <QueryTable
          focusedId={focusedQuiz}
          onSelectionChanged={TableSelectionChanged}
          onRowClick={TableRowClick}
          primaryActions={<AddButton onClick={showAddModal}/>}
          secondaryActions={secondaryActions}
          {...query} />
        <QuizDrawer
          quizId={focusedQuiz}
          open={focusedQuiz !== -1}
        />
      </div>
    </div>
  );
};

export default QuizList;
